import _ from "lodash";

export const omitNilValues = obj => _.pickBy(obj, _.identity);
